import React from "react";
import { Navigate } from "react-router-dom";
import { PrivateRouteProps } from "../../types/types";

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  isAuthenticated,
  role,
  allowedRoles,
  redirectTo,
  Component,
}) => {
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/auth/login" />;
  }

  return <Component />;
};

export default PrivateRoute;
